import React from 'react';
import {Carousel} from "@mantine/carousel";
import S from './Industries.module.scss';

import ExtractiveIndustryIcon from '../../shared/assets/images/industries_ExtractiveIndustry.png';
import ProcessAutomationIcon from '../../shared/assets/images/industries_ProcessAutomation.png';
import AirplaneIcon from '../../shared/assets/images/industries_AirplaneIcon.png';

export const Industries = () => {
  return (
    <section className={S.container} id='industries'>
      <div className={S.industries}>
        <h1 className={S.title}>Отрасли применения</h1>

        <Carousel
          classNames={{controls: S.controls, root: S.carouselRoot}}
          className={S.containerCards}
          slideSize={{ base: '100%', sm: '100%', md: '45%' }}
          slideGap={{ base: 'lg', lg: '80px', md: '40px' }}
          emblaOptions={{ loop: true, align: 'start' }}
        >
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>Промышленность</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={ExtractiveIndustryIcon} alt="Добывающая отрасль"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Внедрение продуктов БМК Софт и создание заказных решений</h3>
                    <div>
                      <p className={S.subCardDescription2}>БМК.ТОиР</p>
                      <p className={S.subCardDescription2}>Мобильный обходчик</p>
                      <p className={S.subCardDescription2}>Электронный наряд-заказ</p>
                      <p className={S.subCardDescription2}>Цифровизация бизнес-процессов</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>ИТ-компании</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={ProcessAutomationIcon} alt="Автоматизация процессов"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Автоматизация процессов</h3>
                    <p className={S.subCardDescription}>
                      Разработка корпоративных информационных систем и автоматизация ключевых бизнес-процессов
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>Авиация</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={AirplaneIcon} alt="Хендлинговые компании и Аэропорты"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Хендлинговые компании и Аэропорты</h3>
                    <p className={S.subCardDescription}>
                      Разработка, внедрение и ввод в эксплуатацию систем управления ресурсами, учета услуг и биллинга
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>Промышленность</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={ExtractiveIndustryIcon} alt="Добывающая отрасль"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Внедрение продуктов БМК Софт и создание заказных решений</h3>
                    <div>
                      <p className={S.subCardDescription2}>БМК.ТОиР</p>
                      <p className={S.subCardDescription2}>Мобильный обходчик</p>
                      <p className={S.subCardDescription2}>Электронный наряд-заказ</p>
                      <p className={S.subCardDescription2}>Цифровизация бизнес-процессов</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>ИТ-компании</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={ProcessAutomationIcon} alt="Автоматизация процессов"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Автоматизация процессов</h3>
                    <p className={S.subCardDescription}>
                      Разработка корпоративных информационных систем и автоматизация ключевых бизнес-процессов
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
          <Carousel.Slide>
            <div className={S.card}>
              <p className={S.cardTitle}>Авиация</p>

              <div className={S.cardContent}>
                <div className={S.subCard}>
                  <div className={S.subCardIcon}>
                    <img src={AirplaneIcon} alt="Хендлинговые компании и Аэропорты"/>
                  </div>
                  <div className={S.subCardText}>
                    <h3 className={S.subCardTitle}>Хендлинговые компании и Аэропорты</h3>
                    <p className={S.subCardDescription}>
                      Разработка, внедрение и ввод в эксплуатацию систем управления ресурсами, учета услуг и биллинга
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Carousel.Slide>
        </Carousel>
      </div>
    </section>
  );
};